export const BASE_URL = process.cwd();

export const HEADER_SMALL_SCREEN = '3rem';
export const HEADER_LARGE_SCREEN = '5rem';

export const FOOTER_SMALL_SCREEN = '3rem';
export const FOOTER_LARGE_SCREEN = '2rem';

export const IS_DARK_MODE_KEY = 'isDarkMode';
